import styled from 'styled-components';

export const WrapperButton = styled.div`
    border: 0;
    margin: 0;
    padding: 0;
    outline: 0;
    background-color: transparent;
    cursor: pointer;
`;
